import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupWarehouse } from "../../../Shared/NewForms/NFLookupWarehouse";
import { NFLookupDivision } from "../../../Shared/NewForms/NFLookupDivision";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFLookupCurrency } from "../../../Shared/NewForms/NFlookupCurrency";
import { NFLookupVendorCustomer } from "../../../Shared/NewForms/NFLookupVendorCustomer";

export const ProductionAndSalesWithPaymentsDetailMain = () => {
    const { t } = useTranslation();
    const { watch } = useFormContext();
    return (
        <>
            <Row>
                <Col sm={6}>
                    <NFTextInput
                        title={t("Document#")}
                        disabled
                        fieldName={"documentNumber"}
                    />
                </Col>
                <Col sm={6}>
                    <NFDateInput
                        title={t("DocumentDate")}
                        fieldName={"documentDate"}
                        required={true}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupWarehouse
                        title={t("Warehouse")}
                        fieldName="warehouseId"
                        companyId={watch("companyId")}
                    />
                </Col>
                <Col sm={6}>
                    <NFLookupVendorCustomer
                        title={t("Customer")}
                        fieldName="customerId"
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupDivision
                    companyId={watch('companyId')}
                        title={t("Division")}
                        fieldName="divisionId"
                    />
                </Col>
                <Col sm={6}>
                    <NFLookupCurrency
                        title={t("Currency")}
                        fieldName="currencyId"
                    />
                </Col>
            </Row>
        </>
    );
};
